module["exports"] = [
  "كتب",
  "ألعاب",
  "إلكترونيات",
  "حواسيب",
  "بيت",
  "حديقة",
  "أدوات",
  "بقالة",
  "صحة",
  "جمال",
  "ألعاب",
  "أطفال",
  "رضع",
  "ملابس",
  "أحذية",
  "مجوهرات",
  "أغراض رياضية",
  "في الهواء الطلق",
  "السيارات",
  "صناعة"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ar/commerce/department.js
// module id = 2394
// module chunks = 1609